import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const DeliveryPartnerRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);

  return userInfo && userInfo.deliveryPartner?.isDeliveryPartner? <Outlet /> : <Navigate to="/deliverypartner/login" replace />;
};

export default DeliveryPartnerRoute;